<app-modal-v2 #modal customClassName="diary-form-element-settings-modal">
  <div class="modal-content">

    <div class="modal-header">
      <h2 class="modal-title">{{ supportLink.id ? 'Update' : 'Add' }} Support Link</h2>

      <div class="culture-select">
        <app-input-select #cultureSelect [items]="filteredCultures" [parentForm]="form" controlName="selectedCulture" [allowFiltering]="true" [allowClear]="false" (onFilter)="onCultureFiltered($event)" searchInputPlaceholder="Search..."></app-input-select>
      </div>
    </div>
    <div class="modal-body">
      <!-- Start: Culture Forms -->
      @for (cultureForm of cultureForms; track form) {
        <form [formGroup]="cultureForm" [ngClass]="{'visibility-hidden': cultureForm.value.culture !== form.value.selectedCulture}">
          <div class="form-group">
            <label for="name">Label</label>
            <input type="text" formControlName="label" class="form-control"/>
          </div>
        </form>
      }
      <!-- End: Culture Forms -->

      <!-- Start: Default Form -->
      <form [formGroup]="form" [class.visibility-hidden]="form.value.selectedCulture !== 'en'">
        <div class="form-group">
          <label for="name">Label <sup>*</sup></label>
          <input type="text" formControlName="label" class="form-control" />
        </div>

        <div class="form-group">
          <label for="name">URL <sup>*</sup></label>
          <input type="text" formControlName="url" class="form-control"/>
        </div>

        <div class="form-group" [class.visibility-hidden]="form.value.allCountries">
          <label for="name">Countries</label>
          <app-input-multi-select [parentForm]="form" controlName="countries"
                                  [items]="filteredCountries" inputPlaceholder="Select countries"
                                  searchInputPlaceholder="Search for country..." (onFilter)="onCountryFiltered($event)" [allowFiltering]="true"></app-input-multi-select>
        </div>

        <div class="form-group">
          <label class="checkbox" style="padding-left: 0">
            <input type="checkbox" id="allCountries" formControlName="allCountries">
            <span></span>
          </label>
          <label class="checkbox-label" for="allCountries" style="padding-left: 0; font-size: 12px;">
            All Countries
          </label>
        </div>
      </form>
      <!-- End: Default Form -->
    </div>

    <div class="modal-footer">
      <div class="modal-footer-buttons">
        <app-button text="Cancel" variant="secondary" width="fill"
                    type="button" (click)="modal.hide()"/>

        <app-button text="Save" variant="primary" width="fill" [isBusy]="form.value.isBusy"
                    [disabled]="!form.valid"
                    type="button"
                    (click)="onSubmitForm()"/>
      </div>
    </div>

  </div>
</app-modal-v2>
